import ProcessReceiptLogo from '@/assets/icons/processReceiptLogo.svg?react';
import { Link } from 'wouter';

export default function ProcessingReceiptItem({ receiptId }: { receiptId: string }) {
  return (
    <Link href={`/receipts/${receiptId}`}>
      <div className="flex cursor-pointer items-center justify-between border-b border-gray-100 py-1.5">
        <div className="flex items-center space-x-5">
          <div className="bg-primary-platinum flex h-8 w-8 shrink-0 items-center justify-center rounded">
            <ProcessReceiptLogo />
          </div>
          <div>
            <p className="max-w-[200px] truncate text-base font-bold">New receipt</p>
            <div className="flex flex-row gap-1">
              <p className="text-xs font-normal opacity-70">Added today</p>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
}
